export const ALL_CATEGORY_ID = 'all'
export const TOP_CATEGORY_ID = 'top'
export const ALL_ACCOUNT_CATEGORY_TITLE = 'All Account Types'
export const TRANSFER_CATEGORY_ID = 'transfer'
export const INVESTMENT_CATEGORY_ID = 'investment'
export const ASSET_OTHER_CATEGORY_ID = 'asset_other'
